import React from "react";
import ViewRiasedTicket from "./ViewRiasedTicket";

const ViewRiasedTicketMain = () => {
  return <ViewRiasedTicket />;
};

export default ViewRiasedTicketMain;
